import React from "react";
import { useField, useFormikContext } from "formik";

// material
import {
  Box,
  Button,
  Container,
  Card,
  CardHeader,
  CardContent,
  FormControl,
  IconButton,
  MenuItem,
  Typography,
  TextField,
  Stack,
} from "@mui/material";

// components
import Page from "../../../components/Page";
import CancelIcon from "@mui/icons-material/Cancel";

// ----------------------------------------------------------------------

const reportNoOption = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
  {
    value: 6,
    label: "6",
  },
  {
    value: 7,
    label: "7",
  },
  {
    value: 8,
    label: "8",
  },
  {
    value: 9,
    label: "9",
  },
  {
    value: 10,
    label: "10",
  },
];

const scholarshipOption = [
  {
    value: "1/2019",
    label: "Semester 1/2019 (Batch 1)",
  },
  {
    value: "2/2019",
    label: "Semester 2/2019 (Batch 2)",
  },
  {
    value: "1/2020",
    label: "Semester 1/2020 (Batch 3)",
  },
  {
    value: "2/2020",
    label: "Semester 2/2020 (Batch 4)",
  },
  {
    value: "1/2021",
    label: "Semester 1/2021 (Batch 5)",
  },
  {
    value: "2/2021",
    label: "Semester 2/2021 (Batch 6)",
  },
  {
    value: "1/2022",
    label: "Semester 1/2022 (Batch 7)",
  },
  {
    value: "2/2022",
    label: "Semester 2/2022 (Batch 8)",
  },
  {
    value: "1/2023",
    label: "Semester 1/2023 (Batch 9)",
  },
  {
    value: "2/2023",
    label: "Semester 2/2023 (Batch 10)",
  },
  {
    value: "1/2024",
    label: "Semester 1/2024 (Batch 11)",
  },
  {
    value: "2/2024",
    label: "Semester 2/2024 (Batch 12)",
  },
  {
    value: "1/2025",
    label: "Semester 1/2025 (Batch 13)",
  },
  {
    value: "1/2025",
    label: "Semester 1/2025 (Batch 14)",
  },
];

const previousOption = [
  {
    value: "semester1/2021",
    label: "Semester 1/2021",
  },
  {
    value: "semester2/2021",
    label: "Semester 2/2021",
  },
  {
    value: "semester1/2022",
    label: "semester 1/2022",
  },
  {
    value: "semester2/2022",
    label: "Semester 2/2022",
  },
  {
    value: "semester1/2023",
    label: "Semester 1/2023",
  },
  {
    value: "semester2/2023",
    label: "Semester 2/2023",
  },
  {
    value: "semester1/2024",
    label: "Semester 1/2024",
  },
  {
    value: "semester2/2024",
    label: "Semester 2/2024",
  },
  {
    value: "semester1/2025",
    label: "Semester 1/2025",
  },
  {
    value: "semester2/2025",
    label: "Semester 2/2025",
  },
  {
    value: "semester1/2026",
    label: "Semester 1/2026",
  },
  {
    value: "semester2/2026",
    label: "Semester 2/2026",
  },
  {
    value: "semester1/2027",
    label: "Semester 1/2027",
  },
  {
    value: "semester2/2027",
    label: "Semester 2/2027",
  },
];

export default function UploadFormPage2A(props) {
  const formikProps = useFormikContext();

  const {
    formField: {
      receivingScholarship,
      reportNo,
      previousSemester,
      inputList,
      receivedGradeReportGpa,
      thesisCreditsProgram,
      currentTotalThesisCredits,
      remainingThesisCreditsProgram,
      gpa,
      gpax,
      currentTotalCredits,
      remainingCreditsProgram,
      researchTitleSelect,
      mainResearchArea,
      researchTitle,
    },
  } = props;

  const [receivingScholarshipField, receivingScholarshipMeta] =
    useField(receivingScholarship);
  const [reportNoField, reportNoMeta] = useField(reportNo);
  const [previousSemesterField, previousSemesterMeta] =
    useField(previousSemester);
  const [inputListField, inputListMeta] = useField(inputList);
  const [receivedGradeReportGpaField, receivedGradeReportGpaMeta] = useField(
    receivedGradeReportGpa
  );
  const [thesisCreditsProgramField, thesisCreditsProgramMeta] =
    useField(thesisCreditsProgram);
  const [currentTotalThesisCreditsField, currentTotalThesisCreditsMeta] =
    useField(currentTotalThesisCredits);
  const [
    remainingThesisCreditsProgramField,
    remainingThesisCreditsProgramMeta,
  ] = useField(remainingThesisCreditsProgram);
  const [gpaField, gpaMeta] = useField(gpa);
  const [gpaxField, gpaxMeta] = useField(gpax);
  const [currentTotalCreditsField, currentTotalCreditsMeta] =
    useField(currentTotalCredits);
  const [remainingCreditsProgramField, remainingCreditsProgramMeta] = useField(
    remainingCreditsProgram
  );
  const [researchTitleSelectField, researchTitleSelectMeta] =
    useField(researchTitleSelect);
  const [mainResearchAreaField, mainResearchAreaMeta] =
    useField(mainResearchArea);
  const [researchTitleField, researchTitleMeta] = useField(researchTitle);

  const handleRemoveClick = (index) => {
    const list = [...inputListField.value];
    list.splice(index, 1);
    formikProps.setFieldValue(inputList.name, list);
  };

  const handleAddClick = () => {
    formikProps.setFieldValue(inputList.name, [
      ...inputListField.value,
      { subjectCourseNo: "", courseTitle: "", credit: "", grade: "" },
    ]);
  };

  return (
    <Page title="2A: Grade Report For Previous Semester">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">
            PART: Grade/Progress/Final Report (Continue)
          </Typography>
        </Box>
        <Box sx={{ pb: 5 }}>
          <Typography variant="h5">
            2A: Grade Report For Previous Semester
          </Typography>
        </Box>
        <Stack
          direction="column"
          justifyContent="space-evenly"
          alignItems="stretch"
          spacing={4}
        >
          <Stack direction="row" spacing={12}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {receivingScholarship.label}
              </Typography>
              <TextField
                select
                variant="outlined"
                name={receivingScholarshipField.name}
                value={receivingScholarshipField.value}
                onChange={(e) => receivingScholarshipField.onChange(e)}
                error={Boolean(
                  receivingScholarshipMeta.touched &&
                    receivingScholarshipMeta.error
                )}
                helperText={
                  receivingScholarshipMeta.touched &&
                  receivingScholarshipMeta.error
                }
              >
                {scholarshipOption.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">{reportNo.label}</Typography>
              <TextField
                select
                variant="outlined"
                name={reportNoField.name}
                value={reportNoField.value}
                onChange={(e) => reportNoField.onChange(e)}
                error={Boolean(reportNoMeta.touched && reportNoMeta.error)}
                helperText={reportNoMeta.touched && reportNoMeta.error}
              >
                {reportNoOption.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {previousSemester.label}
              </Typography>
              <TextField
                select
                variant="outlined"
                name={previousSemesterField.name}
                value={previousSemesterField.value}
                onChange={(e) => previousSemesterField.onChange(e)}
                error={Boolean(
                  previousSemesterMeta.touched && previousSemesterMeta.error
                )}
                helperText={
                  previousSemesterMeta.touched && previousSemesterMeta.error
                }
              >
                {previousOption.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Stack>

          <Typography variant="h6">
            Grade Report/Study Report of the previous semester
          </Typography>
          <Typography variant="subtitle2">
            Please report all registed subject(s) in the previous semester and
            indicate received grade(s).
          </Typography>

          {inputListField.value?.map((x, i) => {
            return (
              <Box key={i}>
                <Card>
                  <CardHeader
                    action={
                      i !== 0 && (
                        <IconButton
                          aria-label="settings"
                          onClick={() => handleRemoveClick(i)}
                          sx={{ color: "#DE5C8E" }}
                        >
                          <CancelIcon />
                        </IconButton>
                      )
                    }
                  />
                  <CardContent>
                    <Stack direction="row" spacing={6}>
                      <FormControl fullWidth>
                        <Typography variant="subtitle2">
                          {inputList.subMenu[0].subjectCourseNo.label}
                        </Typography>
                        <TextField
                          name={inputList.subMenu[0].subjectCourseNo.name}
                          value={inputListField.value[i].subjectCourseNo}
                          onChange={(e) => {
                            formikProps.setFieldValue(
                              `inputList.${i}.subjectCourseNo`,
                              e.target.value
                            );
                          }}
                          error={Boolean(
                            inputListMeta.error
                              ? inputListMeta.touched &&
                                  inputListMeta.error[i]?.subjectCourseNo
                              : false
                          )}
                          helperText={
                            inputListMeta.error
                              ? inputListMeta.touched &&
                                inputListMeta.error[i]?.subjectCourseNo
                              : ""
                          }
                        />
                      </FormControl>

                      <FormControl fullWidth>
                        <Typography variant="subtitle2">
                          {inputList.subMenu[0].courseTitle.label}
                        </Typography>
                        <TextField
                          name={inputList.subMenu[0].courseTitle.name}
                          value={inputListField.value[i].courseTitle}
                          onChange={(e) => {
                            formikProps.setFieldValue(
                              `inputList.${i}.courseTitle`,
                              e.target.value
                            );
                          }}
                          error={Boolean(
                            inputListMeta.error
                              ? inputListMeta.touched &&
                                  inputListMeta.error[i]?.courseTitle
                              : false
                          )}
                          helperText={
                            inputListMeta.error
                              ? inputListMeta.touched &&
                                inputListMeta.error[i]?.courseTitle
                              : ""
                          }
                        />
                      </FormControl>

                      <FormControl fullWidth>
                        <Typography variant="subtitle2">
                          {inputList.subMenu[0].credit.label}
                        </Typography>
                        <TextField
                          name={inputList.subMenu[0].credit.name}
                          value={inputListField.value[i].credit}
                          onChange={(e) => {
                            formikProps.setFieldValue(
                              `inputList.${i}.credit`,
                              e.target.value
                            );
                          }}
                          error={Boolean(
                            inputListMeta.error
                              ? inputListMeta.touched &&
                                  inputListMeta.error[i]?.credit
                              : false
                          )}
                          helperText={
                            inputListMeta.error
                              ? inputListMeta.touched &&
                                inputListMeta.error[i]?.credit
                              : ""
                          }
                        />
                      </FormControl>

                      <FormControl fullWidth>
                        <Typography variant="subtitle2">
                          {inputList.subMenu[0].grade.label}
                        </Typography>
                        <TextField
                          name={inputList.subMenu[0].grade.name}
                          value={inputListField.value[i].grade}
                          onChange={(e) => {
                            formikProps.setFieldValue(
                              `inputList.${i}.grade`,
                              e.target.value
                            );
                          }}
                          error={Boolean(
                            inputListMeta.error
                              ? inputListMeta.touched &&
                                  inputListMeta.error[i]?.grade
                              : false
                          )}
                          helperText={
                            inputListMeta.error
                              ? inputListMeta.touched &&
                                inputListMeta.error[i]?.grade
                              : ""
                          }
                        />
                      </FormControl>
                    </Stack>
                  </CardContent>
                </Card>

                <Box sx={{ paddingTop: 3 }}>
                  {inputListField.value?.length - 1 === i && (
                    <Button
                      onClick={handleAddClick}
                      variant="contained"
                      size="large"
                    >
                      Add More Subject
                    </Button>
                  )}
                </Box>
              </Box>
            );
          })}

          <Stack spacing={3}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {receivedGradeReportGpa.label}
              </Typography>
              <TextField
                multiline
                rows={4}
                name={receivedGradeReportGpaField.name}
                value={receivedGradeReportGpaField.value}
                onChange={(e) => receivedGradeReportGpaField.onChange(e)}
                error={Boolean(
                  receivedGradeReportGpaMeta.touched &&
                    receivedGradeReportGpaMeta.error
                )}
                helperText={
                  receivedGradeReportGpaMeta.touched &&
                  receivedGradeReportGpaMeta.error
                }
              />
            </FormControl>

            <Typography variant="h6">Thesis Report</Typography>

            <Stack direction="row" spacing={6}>
              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {thesisCreditsProgram.label}
                </Typography>
                <TextField
                  name={thesisCreditsProgramField.name}
                  value={thesisCreditsProgramField.value}
                  onChange={(e) => thesisCreditsProgramField.onChange(e)}
                  error={Boolean(
                    thesisCreditsProgramMeta.touched &&
                      thesisCreditsProgramMeta.error
                  )}
                  helperText={
                    thesisCreditsProgramMeta.touched &&
                    thesisCreditsProgramMeta.error
                  }
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {currentTotalThesisCredits.label}
                </Typography>
                <TextField
                  name={currentTotalThesisCreditsField.name}
                  value={currentTotalThesisCreditsField.value}
                  onChange={(e) => currentTotalThesisCreditsField.onChange(e)}
                  error={Boolean(
                    currentTotalThesisCreditsMeta.touched &&
                      currentTotalThesisCreditsMeta.error
                  )}
                  helperText={
                    currentTotalThesisCreditsMeta.touched &&
                    currentTotalThesisCreditsMeta.error
                  }
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {remainingThesisCreditsProgram.label}
                </Typography>
                <TextField
                  name={remainingThesisCreditsProgramField.name}
                  value={remainingThesisCreditsProgramField.value}
                  onChange={(e) =>
                    remainingThesisCreditsProgramField.onChange(e)
                  }
                  error={Boolean(
                    remainingThesisCreditsProgramMeta.touched &&
                      remainingThesisCreditsProgramMeta.error
                  )}
                  helperText={
                    remainingThesisCreditsProgramMeta.touched &&
                    remainingThesisCreditsProgramMeta.error
                  }
                />
              </FormControl>
            </Stack>

            <Typography variant="h6">Study Summary</Typography>

            <Stack direction="row" spacing={6}>
              <FormControl fullWidth>
                <Typography variant="subtitle2">{gpa.label}</Typography>
                <TextField
                  name={gpaField.name}
                  value={gpaField.value}
                  onChange={(e) => gpaField.onChange(e)}
                  error={Boolean(gpaMeta.touched && gpaMeta.error)}
                  helperText={gpaMeta.touched && gpaMeta.error}
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="subtitle2">{gpax.label}</Typography>
                <TextField
                  name={gpaxField.name}
                  value={gpaxField.value}
                  onChange={(e) => gpaxField.onChange(e)}
                  error={Boolean(gpaxMeta.touched && gpaxMeta.error)}
                  helperText={gpaxMeta.touched && gpaxMeta.error}
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {currentTotalCredits.label}
                </Typography>
                <TextField
                  name={currentTotalCreditsField.name}
                  value={currentTotalCreditsField.value}
                  onChange={(e) => currentTotalCreditsField.onChange(e)}
                  error={Boolean(
                    currentTotalCreditsMeta.touched &&
                      currentTotalCreditsMeta.error
                  )}
                  helperText={
                    currentTotalCreditsMeta.touched &&
                    currentTotalCreditsMeta.error
                  }
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {remainingCreditsProgram.label}
                </Typography>
                <TextField
                  name={remainingCreditsProgramField.name}
                  value={remainingCreditsProgramField.value}
                  onChange={(e) => remainingCreditsProgramField.onChange(e)}
                  error={Boolean(
                    remainingCreditsProgramMeta.touched &&
                      remainingCreditsProgramMeta.error
                  )}
                  helperText={
                    remainingCreditsProgramMeta.touched &&
                    remainingCreditsProgramMeta.error
                  }
                />
              </FormControl>
            </Stack>

            <Stack direction="row" spacing={6}>
              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {researchTitleSelect.label}
                </Typography>
                <TextField
                  select
                  variant="outlined"
                  name={researchTitleSelectField.name}
                  value={researchTitleSelectField.value}
                  onChange={(e) => researchTitleSelectField.onChange(e)}
                  error={Boolean(
                    researchTitleSelectMeta.touched &&
                      researchTitleSelectMeta.error
                  )}
                  helperText={
                    researchTitleSelectMeta.touched &&
                    researchTitleSelectMeta.error
                  }
                >
                  <MenuItem value={"science_field"}>Science field</MenuItem>
                  <MenuItem value={"humanities_and_social_science"}>
                    Humanities and Social Science
                  </MenuItem>
                </TextField>
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {mainResearchArea.label}
                </Typography>
                <TextField
                  name={mainResearchAreaField.name}
                  value={mainResearchAreaField.value}
                  onChange={(e) => mainResearchAreaField.onChange(e)}
                  error={Boolean(
                    mainResearchAreaMeta.touched && mainResearchAreaMeta.error
                  )}
                  helperText={
                    mainResearchAreaMeta.touched && mainResearchAreaMeta.error
                  }
                />
                <Typography>
                  {
                    "For example: Science field >> Chemical engineering, Humanities and Social science >> Education and Gender"
                  }
                </Typography>
              </FormControl>
            </Stack>

            <FormControl fullWidth>
              <Typography variant="subtitle2">{researchTitle.label}</Typography>
              <TextField
                name={researchTitleField.name}
                value={researchTitleField.value}
                onChange={(e) => researchTitleField.onChange(e)}
                error={Boolean(
                  researchTitleMeta.touched && researchTitleMeta.error
                )}
                helperText={
                  researchTitleMeta.touched && researchTitleMeta.error
                }
              />
            </FormControl>
          </Stack>
        </Stack>
      </Container>
    </Page>
  );
}
